import React from 'react';
import { School } from 'lucide-react';

const ShardLoader = ({ text = "Loading module..." }) => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] w-full p-8 animate-fade-in">
            <div className="relative flex items-center justify-center">
                {/* Shard Decoration Layer */}
                <div className="absolute flex items-center justify-center gap-3">
                    {/* Shard 1 (Left Outer) */}
                    <div
                        className="w-1.5 h-16 bg-gradient-to-b from-transparent via-[#1a3884]/40 to-transparent rounded-sm animate-shard-pulse backdrop-blur-sm"
                        style={{ animationDelay: '0s' }}
                    ></div>

                    {/* Shard 2 (Left Inner) */}
                    <div
                        className="w-2.5 h-24 bg-gradient-to-b from-transparent via-[#1a3884]/50 to-transparent rounded-sm animate-shard-pulse backdrop-blur-md"
                        style={{ animationDelay: '0.4s' }}
                    ></div>

                    {/* Center Gap for Logo */}
                    <div className="w-16"></div>

                    {/* Shard 3 (Right Inner) */}
                    <div
                        className="w-2.5 h-24 bg-gradient-to-b from-transparent via-[#1a3884]/50 to-transparent rounded-sm animate-shard-pulse backdrop-blur-md"
                        style={{ animationDelay: '0.6s' }}
                    ></div>

                    {/* Shard 4 (Right Outer) */}
                    <div
                        className="w-1.5 h-16 bg-gradient-to-b from-transparent via-[#1a3884]/40 to-transparent rounded-sm animate-shard-pulse backdrop-blur-sm"
                        style={{ animationDelay: '0.2s' }}
                    ></div>
                </div>

                {/* Central Shard Effect Behind Logo */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-32 bg-gradient-to-b from-[#1a3884]/0 via-[#1a3884]/30 to-[#1a3884]/0 rounded-full blur-xl animate-pulse"></div>
                </div>

                {/* Logo Container */}
                <div className="relative z-10 flex items-center justify-center w-16 h-16 bg-white/90 rounded-2xl shadow-lg border border-[#1a3884]/20 backdrop-blur-xl">
                    <School className="w-8 h-8 text-[#1a3884]" />
                </div>
            </div>

            {/* Loading Text */}
            <div className="mt-8 text-center space-y-1 relative z-10">
                <p className="text-sm font-medium text-gray-500 uppercase tracking-widest animate-pulse">
                    {text}
                </p>
            </div>
        </div>
    );
};

export default ShardLoader;
